import React, { useState, useContext } from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import { PlayCircle, PlusCircle } from "react-bootstrap-icons"
import CommentSection from "../comments/CommentSection"
import { useDispatch } from "react-redux"
import { prependAndPlay } from "../../stores/mediaPlayerSlice"
import { openSongActions } from "../../stores/songActionsSlice"
import { PostListItemExpandedStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { AnchorButton, ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import PremiereHeader from "./PremiereHeader"
import clsx from "clsx"
import styles from "./styles.module.css"
import { UserContext } from "../HomeApp"
import EditManageHeader from "../EditManageHeader"
import { TextAsImage } from "./TextAsImage"
import { usePost } from "../../hooks/usePost"

const ICON_SIZE = "1.6rem"
const MARGIN_SPACING = "0rem 0.5rem 0rem 0"

export const StandAloneSongListItemExpanded = ({
  song,
  updateStatus,
  adminMode = false,
  isPostPage = false,
}) => {
  const metaClass = isPostPage
    ? "col-span-12 pt-2"
    : PostListItemExpandedStyles.metaDiv
  const commentsClass = isPostPage
    ? "col-span-12 pt-4"
    : PostListItemExpandedStyles.commentsDiv
  const [postStatus, setPostStatus] = useState(song.status)
  const [showEditForm, setShowEditForm] = useState(false)
  const { user } = useContext(UserContext)
  const isOwner = user && user.band && user.band.id === song.band_id
  const songDetailData = usePost(song.id)
  const songDetails = songDetailData?.data?.post

  const dispatch = useDispatch()

  const onPlayClick = () => {
    dispatch(prependAndPlay(mappedSong()))
  }

  const onAddClick = () => {
    dispatch(openSongActions(mappedSong()[0]))
  }

  const mappedSong = () => {
    return [song].map((song) => ({
      ...song,
      album_name: song.title,
      cover_image_small: song.external_photo_src,
    }))
  }

  return (
    <div className="grid grid-cols-12">
      <PremiereHeader post={song} size="large" />
      {song.external_photo_src ? (
        <div className={PostListItemExpandedStyles.contentDiv}>
          <img
            src={song.external_photo_src}
            alt={song.title}
            className="w-full"
            style={{ aspectRatio: "1/1" }}
          />
        </div>
      ) : (
        <TextAsImage text={song.title} expanded />
      )}
      <div className={metaClass}>
        <EditManageHeader
          isOwner={isOwner}
          post={song}
          setShowEditForm={setShowEditForm}
        />
        <div className="flex">
          <div className="flex flex-none">
            <PlayCircle
              className="cursor-pointer"
              style={{
                minWidth: ICON_SIZE,
                width: ICON_SIZE,
                height: ICON_SIZE,
                margin: MARGIN_SPACING,
              }}
              onClick={onPlayClick}
            />
            <PlusCircle
              className="cursor-pointer"
              style={{
                minWidth: ICON_SIZE,
                width: ICON_SIZE,
                height: ICON_SIZE,
                margin: MARGIN_SPACING,
              }}
              onClick={onAddClick}
            />
          </div>

          <div className="flex items-start justify-between flex-grow">
            <h2
              className={clsx(
                PostListItemExpandedStyles.header,
                "inline mr-2",
                song.is_bn_premiere && styles.premiereTitle,
              )}
              dangerouslySetInnerHTML={{ __html: song.title }}
            ></h2>
            <ShareUrlButton nadaUrl={song.nada_url} renderMode="button" />
          </div>
        </div>
        <h3>
          <Link
            className={PostListItemExpandedStyles.bandName}
            to={song.local_path}
          >
            {song.band_name}
          </Link>
        </h3>
        <div className="text-xs">
          {!song.is_released ? (
            <div>
              Announced&nbsp;
              {SmartDateFormat({
                dateStr: song.announced_at,
                includeTime: false,
              })}
              &nbsp;for Release on&nbsp;
              {SmartDateFormat({
                dateStr: song.published_at,
                includeTime: false,
              })}
            </div>
          ) : (
            <div>
              Released&nbsp;
              {SmartDateFormat({
                dateStr: song.published_at,
                includeTime: false,
              })}
            </div>
          )}
        </div>
        <div className={PostListItemExpandedStyles.externalLink}>
          {song.class_name === "Bandcamp" ? (
            <div className="mt-1">
              <AnchorButton href={song.external_url} target="_blank">
                Buy on&nbsp;
                {song.class_name}
              </AnchorButton>
            </div>
          ) : (
            <a href={song.external_url} target="_blank" rel="noreferrer">
              view on&nbsp;
              {song.class_name}
            </a>
          )}
        </div>

        {songDetails && (songDetails.about || songDetails.credits) && (
          <div className="mt-4 text-xs text-gray-700 space-y-3">
            {songDetails.about && (
              <p className="whitespace-pre-line mb-2">{songDetails.about}</p>
            )}
            {songDetails.credits && (
              <p className="whitespace-pre-line">{songDetails.credits}</p>
            )}
          </div>
        )}
        <div className="mt-4 text-black" style={{ display: "flex" }}>
          <PlayCircle
            className="cursor-pointer"
            style={{
              minWidth: ICON_SIZE,
              width: ICON_SIZE,
              height: ICON_SIZE,
              margin: MARGIN_SPACING,
            }}
            onClick={onPlayClick}
          />
          <PlusCircle
            className="cursor-pointer"
            style={{
              minWidth: ICON_SIZE,
              width: ICON_SIZE,
              height: ICON_SIZE,
              margin: MARGIN_SPACING,
            }}
            onClick={onAddClick}
          />
          <span className="font-bold">1.</span>
          &nbsp;
          <span className="text-gray-700">{song.title}</span>
        </div>
      </div>
      <div className={commentsClass}>
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}

        <RelatedPosts postId={song.id} className="mb-4" />

        <ReactionBlock
          contentType="Post"
          contentId={song.id}
          postId={song.id}
        />

        <div className="mb-4" />

        <CommentSection
          postId={song.id}
          headerText="The Peanut Gallery Says:"
          className="mb-4"
        />
      </div>
    </div>
  )
}
